var _g, _rect, _rect2, _rect3, _path, _circle, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_205_595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 150,
    height: 150,
    rx: 8,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 84,
    width: 118,
    height: 41,
    rx: 2,
    fill: "#F3F3F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6,
    y: 131.6,
    width: 54.0632,
    height: 17.7474,
    rx: 3.4,
    fill: "white",
    stroke: "#D7D7D7",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 131,
    width: 55.2632,
    height: 18.9474,
    rx: 4,
    fill: "#1A73E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.212 138.573L112.388 144H111.109L113.5 137.602H114.317L114.212 138.573ZM115.737 144L113.904 138.573L113.795 137.602H114.616L117.02 144H115.737ZM115.653 141.623V142.576H112.221V141.623H115.653ZM119.002 137.25V144H117.837V137.25H119.002ZM121.52 137.25V144H120.355V137.25H121.52ZM122.601 141.671V141.579C122.601 141.23 122.65 140.909 122.75 140.616C122.85 140.32 122.995 140.064 123.185 139.847C123.376 139.63 123.608 139.462 123.884 139.342C124.159 139.219 124.473 139.157 124.824 139.157C125.182 139.157 125.498 139.219 125.773 139.342C126.052 139.462 126.286 139.63 126.477 139.847C126.667 140.064 126.812 140.32 126.912 140.616C127.011 140.909 127.061 141.23 127.061 141.579V141.671C127.061 142.017 127.011 142.337 126.912 142.633C126.812 142.926 126.667 143.183 126.477 143.402C126.286 143.619 126.053 143.788 125.778 143.908C125.502 144.028 125.188 144.088 124.833 144.088C124.482 144.088 124.167 144.028 123.888 143.908C123.61 143.788 123.376 143.619 123.185 143.402C122.995 143.183 122.85 142.926 122.75 142.633C122.65 142.337 122.601 142.017 122.601 141.671ZM123.761 141.579V141.671C123.761 141.879 123.781 142.074 123.822 142.255C123.863 142.437 123.926 142.597 124.011 142.734C124.096 142.872 124.206 142.98 124.341 143.06C124.479 143.136 124.643 143.174 124.833 143.174C125.021 143.174 125.182 143.136 125.316 143.06C125.451 142.98 125.561 142.872 125.646 142.734C125.734 142.597 125.798 142.437 125.839 142.255C125.88 142.074 125.901 141.879 125.901 141.671V141.579C125.901 141.374 125.88 141.182 125.839 141.003C125.798 140.821 125.734 140.662 125.646 140.524C125.561 140.383 125.45 140.273 125.312 140.194C125.177 140.112 125.015 140.071 124.824 140.071C124.637 140.071 124.476 140.112 124.341 140.194C124.206 140.273 124.096 140.383 124.011 140.524C123.926 140.662 123.863 140.821 123.822 141.003C123.781 141.182 123.761 141.374 123.761 141.579ZM129.408 142.857L130.449 139.245H131.187L130.968 140.493L129.917 144H129.28L129.408 142.857ZM128.832 139.245L129.614 142.866L129.684 144H128.951L127.703 139.245H128.832ZM132.154 142.813L132.919 139.245H134.044L132.805 144H132.071L132.154 142.813ZM131.302 139.245L132.334 142.822L132.471 144H131.833L130.774 140.493L130.559 139.245H131.302Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91.0003,
    cy: 27.9473,
    r: 7.10526,
    fill: "#D7D7D7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 41.3684,
    width: 105.79,
    height: 3.15789,
    rx: 1.57895,
    fill: "#D7D7D7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 66,
    width: 96,
    height: 5,
    rx: 2.5,
    fill: "#D7D7D7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 49.2632,
    width: 74,
    height: 3.15789,
    rx: 1.57895,
    fill: "#D7D7D7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 63,
    width: 12,
    height: 12,
    fill: "#D7D7D7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 125,
    width: 67,
    height: 31,
    rx: 4,
    stroke: "url(#paint0_linear_205_595)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_205_595",
    x: 0,
    y: 0,
    width: 182,
    height: 182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.188235 0 0 0 0 0.188235 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_205_595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_205_595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_595",
    x1: 89,
    y1: 140.366,
    x2: 159.121,
    y2: 140.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7150AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A954C2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSecond);
export default __webpack_public_path__ + "static/media/help-second.3db0e8746cb1247e69dac9efd6b38e01.svg";
export { ForwardRef as ReactComponent };